<template>
  <div>
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
       <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        style="margin-right:0.5em;border-radius:8px;margin-top:-15px"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <!-- {{usertype}} -->
      <v-card class="box" v-if="usertype == 'Parent'">
        <v-toolbar class="toolbar no-display" flat dense>
          <v-toolbar-title>
            <strong>
              Add Suggesion/Query
            </strong>
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3" md="3">
            <v-autocomplete class="ma-2" :items="standard_list" v-model="standard" item-text="standard"
              item-value="standard_id" label="Standard" dense filled outlined rounded
              @change="getFeedbackDates()"></v-autocomplete>
          </v-col>
          <!-- {{feedback_allowed}} -->
          <!-- <v-btn class="button">Fetch</v-btn> -->
        </v-row>
      </v-card>

      <v-card class="box" v-if="usertype == 'Student'">
        <v-toolbar class="toolbar no-display" flat dense>
          <v-toolbar-title>
            <strong>
              Add Suggesion/Query Student
            </strong>
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3" md="3">
            Standard - {{ standard.standard }}
          </v-col>
        </v-row>
      </v-card>

      <v-card class="box" v-if="standard && feedback_allowed">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Add Suggesion/Query</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="6">
            <v-icon color="error">*</v-icon>
            <v-text-field outlined dense type="text" v-model="title" label="Title"></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col cols="12" sm="6">
            <v-icon color="error">*</v-icon>
            <v-textarea outlined name="input-7-4" v-model="description" label="Enter Description"></v-textarea>
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <v-icon color="error">*</v-icon>
            <v-autocomplete color="#0F2027" dense rounded required v-model="feedback_category"
              :items="feedback_category_list" item-text="value" item-value="value" label="Category" outlined />
          </v-col>
          <v-col cols="12" sm="3">
            <v-icon color="error">*</v-icon>
            <v-autocomplete color="#0F2027" dense rounded required v-model="querytype" :items="querytype_list"
              item-text="name" item-value="id" label="Issue/Suggestion" outlined />
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" sm="3">
            <p><b>Attachment(if Any)</b></p>
            <v-file-input placeholder="Pick File If Any" prepend-icon="mdi-camera" show-size
              v-model="evidance"></v-file-input>
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-btn color="primary" dark class="mb-2" :loading="loader" @click="save()">Save</v-btn>
        </v-row>
      </v-card>
      <hr>
      <v-card class="box" v-if="feedback_list != ''">
        <v-data-table :headers="headers" :items="feedback_list">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Suggesions</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:[`item.is_read`]="{ item }">
            <span v-if="item.is_read">
              <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
            </span>
            <span v-else>
              <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
            </span>
          </template>
          <template v-slot:[`item.file_link`]="{ item }">
            <span v-if="item.file_link != '--'">
              <a class="p-2" :href="awspath + item.file_link" target="blank">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon color="primary">mdi-eye</v-icon></v-btn>
                  </template>
                  <span> View File</span>
                </v-tooltip>
              </a>
            </span>
            <span v-else> -- </span>
          </template>
          <template v-slot:[`item.view_feedback`]="{ item }">
            <span v-if="item.remark != '--'">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon color="black" @click="viewFeedback(item)">mdi-eye</v-icon></v-btn>
                </template>
                <span> View Suggesion/Query</span>
              </v-tooltip>
            </span>
            <span v-else>--</span>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <v-dialog v-model="dialog" max-width="800px" persistent>
      <v-card>
        <v-col cols="12" sm="12" md="12">
          <v-card class="box">
            <v-row dense>

              <p><b>Please give the school Two working days to reply.</b></p>

            </v-row>
            <v-row justify="center" dense>
              <v-btn class="button" @click="dialog = false">Ok</v-btn>
            </v-row>
          </v-card>
        </v-col>
      </v-card>
    </v-dialog>
    <v-row justify="center">
      <v-dialog v-model="feedback_view" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar class="toolbar">
            <v-btn icon dark @click="feedback_view = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Feedback View</v-toolbar-title>
            <v-toolbar-items>
              <v-btn dark text @click="feedback_view = false">Close</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <br>
          <v-row justify="center" dense>
            <v-col cols="12" sm="6" md="6">
              <v-text-field outlined dense type="text" v-model="view_feedback.title" label="Title"
                readonly></v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center" dense>
            <v-col cols="12" sm="6">
              <v-textarea outlined name="input-7-4" v-model="view_feedback.description" label="Description"
                readonly></v-textarea>
            </v-col>
          </v-row>
          <v-row justify="center" dense>
            <v-col cols="12" sm="6" md="6">
              <v-text-field outlined dense type="text" v-model="view_feedback.category" label="Category"
                readonly></v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center" dense>
            <v-col cols="12" sm="3" md="3">
              <v-text-field outlined dense type="text" v-model="view_feedback.feedback_date" label="Date"
                readonly></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <span v-if="view_feedback.file_link != '--'">
                <a class="p-2" :href="awspath + view_feedback.file_link" target="blank">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon color="primary">mdi-eye</v-icon></v-btn>
                    </template>
                    <span> View File</span>
                  </v-tooltip>
                </a>
              </span>
              <span v-else> -- </span>
            </v-col>
          </v-row>
          <v-row justify="center" dense>
            <v-col cols="12" sm="6">
              <p><b>Is Read By School - </b>
                <span v-if="view_feedback.is_read">
                  <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                </span>
                <span v-else>
                  <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                </span>
              </p>
            </v-col>
          </v-row>
          <v-row justify="center" dense>
            <v-col cols="12" sm="6">
              <p><b>Comment From School</b></p>
              <v-textarea outlined name="input-7-4" v-model="view_feedback.remark" label="Comment"
                readonly></v-textarea>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
    </v-row>
    <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span style="color:black">Add Suggestion Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/_ZZn5nJRAEg?si=JnX9zXSJFkfuQZWZ"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
    querytype_list: [], querytype: "",
    feedback_view: false,
    dialog: false,
    loader: false,
    videoDialog:false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    title: "",
    url: "",
    description: "", evidance: null,
    headers: [
      { text: "Sr No", value: "count" },
      { text: "Title", value: "title" },
      // { text: "Description", value: "description" },
      { text: "Category", value: "category" },
      { text: "Query Type", value: "querytype" },
      { text: "Post Date", value: "feedback_date" },
      { text: "Standard", value: "standard" },
      { text: "Academic Year", value: "academicyear" },
      { text: "Attachment", align: "center", sortable: false, value: "file_link", },
      { text: "Is Read By School?", value: "is_read" },
      { text: "Remarks", align: "center", sortable: false, value: "view_feedback", },
    ],
    awspath: null,
    usertype: "", standard_list: [], standard: "", feedback_allowed: true, feedback_category_list: [], overlay: false, feedback_category: "", feedback_list: [],
    view_feedback: {
      title: "", description: "", category: "", file_link: null, remark: "", feedback_date: "", is_read: false,
    }
  }),
  methods: {
    viewFeedback(item) {
      this.view_feedback.title = item.title
      this.view_feedback.description = item.description
      this.view_feedback.remark = item.remark
      this.view_feedback.category = item.category
      this.view_feedback.feedback_date = item.feedback_date
      this.view_feedback.file_link = item.file_link
      this.view_feedback.is_read = item.is_read
      this.feedback_view = true
    },
    getFeedbackDates() {
      this.loader = true;
      this.overlay = true;
      const data = {
        standard: this.standard
      };
      axios
        .post("/Feedback/getFeedbackDates", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.feedback_allowed = res.data.feedback_allowed
          }
          else if (res.data.flag == "No") {
            this.feedback_allowed = res.data.feedback_allowed
            this.showSnackbar("#b71c1c", res.data.snackbar);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
        })
        .finally(() => {
          this.loader = false;
          this.overlay = false;
          // 'use strict';
        });
    },
    clearData() {
      this.title = "", this.standard = "", this.evidance = null, this.description = "", this.feedback_category = ""
    },
    save() {
      // if (!confirm("Suggestions -Please give the school 2 working days to reply put this message to the parent while they send suggestion")) return;
      if (this.title == "" || this.title == null) {
        this.showSnackbar("red", "Enter Title");
        return
      }
      if (this.description == "" || this.description == null) {
        this.showSnackbar("red", "Enter Description");
        return
      }
      if (this.feedback_category == "" || this.feedback_category == null) {
        this.showSnackbar("red", "Please Select Feedback Category");
        return
      }
      if (this.standard == "" || this.standard == null) {
        this.showSnackbar("red", "Please Select Standard");
        return
      }
      this.loader = true
      this.overlay = true
      let formData = new FormData();
      formData.append("file", this.evidance);
      formData.append("title", this.title);
      formData.append("description", this.description);
      if (this.usertype == 'Parent') {
        formData.append("standard", this.standard);
      } else {
        formData.append("standard", this.standard.standard_id);
      }
      formData.append("feedback_category", this.feedback_category);
      formData.append("querytype", this.querytype);
      axios.post("/Feedback/savegenericFeedback", formData).then((res) => {
        if (res.data.flag == "YES") {
          this.showSnackbar("green", "Feedback Posted Successfully...");
          // this.showSnackbar("green", "Please give the school Two working days to reply.");
          this.dialog = true;
          this.feedback_list = res.data.feedback_list
          this.clearData();
        } else {
          this.showSnackbar("red", "Something Went Wrong...");
          this.loader = false
        }
      })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
        })
        .finally(() => {
          this.loader = false
          this.overlay = false
          this.onLoad()
        });
    },
    onLoad() {
      this.overlay = true;
      axios
        .get("/Feedback/getGenericFeedbackInitialData")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.usertype = res.data.usertype
            this.standard_list = res.data.standards,
              this.standard = this.standard_list[0]
            this.feedback_category_list = res.data.feedback_category
            this.feedback_list = res.data.feedback_list
            this.querytype_list = res.data.querytype_list
            this.feedback_allowed = res.data.feedback_allowed
            // this.standard= this.standard_list[0]
          } else if (res.data.flag == "No") {
            this.feedback_allowed = res.data.feedback_allowed
            this.feedback_list = res.data.feedback_list
            this.usertype = res.data.usertype
            this.feedback_category_list = res.data.feedback_category
            this.querytype_list = res.data.querytype_list
            this.standard_list = res.data.standards,
              this.standard = this.standard_list[0]

            this.showSnackbar("#b71c1c", res.data.snackbar);
          }
          else {
            this.showSnackbar("#b71c1c", "Wrong information");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.awspath = localStorage.getItem("awspath");
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
.table-head-background {
  background-color: #fcc96f;
  color: #fff;
  font-weight: 700;
}

.tc-title {
  background-image: linear-gradient(-90deg, #fcc96f, #fcb63c);
  color: #fff;
  font-weight: 700;
  margin: 0px !important;
  padding: 0px !important;
}

.text-left {
  font-size: 14px;
  font-weight: bold;
}

.text {
  color: blue;
  font-weight: 600;
  font-size: 14px;
}
</style>
